import caixaEntrada from '@/App/(authenticated)/modulos/analise/sala-monitoramento/caixa-entrada/caixa-entrada.vue'
import caixaEmDecisao from '@/App/(authenticated)/modulos/analise/sala-monitoramento/caixa-em-decisao/caixa-em-decisao.vue'
import caixaArquivadas from '@/App/(authenticated)/modulos/analise/sala-monitoramento/caixa-arquivadas/caixa-arquivadas.vue'
import analiseProcesso from '@/App/(authenticated)/modulos/analise/sala-monitoramento/analise-processo/analise-processo.vue'

export const items = [
  {
    path: 'caixa-entrada',
    name: 'sala-monitoramento/caixa-entrada',
    component: caixaEntrada,
    meta: {
      routeGroup: 'sala-monitoramento/caixa-entrada'
    }
  },
  {
    path: 'em-decisao',
    name: 'sala-monitoramento/em-decisao',
    component: caixaEmDecisao,
    meta: {
      routeGroup: 'sala-monitoramento/em-decisao'
    }
  },
  {
    path: 'arquivadas',
    name: 'sala-monitoramento/arquivadas',
    component: caixaArquivadas,
    meta: {
      routeGroup: 'sala-monitoramento/arquivadas'
    }
  },
  {
    path: 'analisar/:id',
    name: 'sala-monitoramento/analisar',
    component: analiseProcesso,
    meta: {
      previousRoute: {
        meta: {
          routeGroup: 'sala-monitoramento/em-decisao'
        }
      },
      routeGroup: 'sala-monitoramento/analisar'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/sala-monitoramento/routes.js